<form #filtersForm="ngForm" (submit)="apply()" *ngIf="!hidden">
    <div class="data-filters-container ibox"
         [ngClass]="{ 'full-width': fullWidth, 'no-m-b': noMarginBottom }"
         [ngStyle]="{'width' : size + 'px'}">
        <div class="data-filters-title ibox-title" (click)="showFilters()" *ngIf="showTitle">
            <h2 class="data-filters-title-text" [i18n]="[{target: 'innerHTML', key: titleKey ? titleKey : 'data-table.filters.title'}]"></h2>
            <i class="fa" [ngClass]="{ 'fa-angle-down': !opened, 'fa-angle-up': opened }"></i>
        </div>
        <div class="data-filters ibox-content" [ngClass]="{ 'no-height': !opened }">

            <ng-content select="app-data-filter-group"></ng-content>

        </div>
        <div class="data-filters-footer ibox-content" [ngClass]="{ 'no-height': !opened}">
            <button type="button" class="btn btn-i btn-default pull-left" (click)="reset()">
                <i class="fa fa-ban"></i>
                <span [i18n]="[{target: 'innerHTML', key: 'data-table.filters.buttons.reset'}]"></span>
            </button>

            <div class="helper-container" [ngClass]="helperSide" *ngIf="helper">
                <span [i18n]="helperKey" [ngStyle]="helperColor != null && { color: helperColor}"></span>
            </div>

            <div class="right-buttons">
                <ng-content select="app-data-filters-button"></ng-content>

                <button type="submit" class="btn btn-i btn-primary" [disabled]="disableSearch">
                    <i class="fa fa-check"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'data-table.filters.buttons.apply'}]"></span>
                </button>
            </div>
        </div>
    </div>
</form>
